import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ELocalStorageKey, ERouterName } from '/@/types/index'
import CreatePlan from '/@/components/task/create-plan.vue'
import CreateFlightPlan from '/@/pages/page-web/projects/flightPlan/createPlan.vue'
import WaylinePanel from '/@/pages/page-web/projects/wayline.vue'
import DockPanel from '/@/pages/page-web/projects/dock.vue'
import LiveAgora from '/@/components/livestream-agora.vue'
import LiveOthers from '/@/components/livestream-others.vue'

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/' + ERouterName.PROJECT
  },
  // 登录界面
  // 登录路径：http://localhost:8080/project
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // members, devices

  // pilot
  // 登录路径：http://localhost:8080/pilot-login
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  },
  {
    path: '/share-video',
    component: () => import('/@/pages/page-web/projects/shareVideo.vue')

  },
]
export const dynamicRoutes = [
  {
    path: '/' + ERouterName.SCENARIO,
    name: ERouterName.SCENARIO,
    component: () => import('/@/pages/page-web/scenarios/index.vue'),
    children: [
      {
        path: '/' + ERouterName.SCENARIO_WORKSPACE,
        name: ERouterName.SCENARIO_WORKSPACE,
        component: () => import('/@/pages/page-web/scenarios/scenario.vue'), // 工作中心
        redirect: '/' + ERouterName.SCENARIO_PLAN,
        children: [
          {
            path: '/' + ERouterName.SCENARIO_PLAN,
            name: ERouterName.SCENARIO_PLAN,
            component: () => import('/@/pages/page-web/scenarios/plan.vue'),
          },
          {
            path: '/' + ERouterName.SCENARIO_ICON,
            name: ERouterName.SCENARIO_ICON,
            component: () => import('/@/pages/page-web/scenarios/icon.vue'),
          },
          {
            path: '/scenario-plan-detail',
            name: 'ScenarioPlanDetail',
            component: () => import('/@/pages/page-web/scenarios/plan_detail.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/' + ERouterName.HOME,
    name: ERouterName.HOME,
    component: () => import('/@/pages/page-web/home.vue'), // 业务中心主界面
    children: [
      {
        path: '/notie-detail',
        name: 'notie-detail',
        component: () => import('/@/pages/page-web/projects/notie-detail.vue')
      },
      {
        path: '/' + ERouterName.WORKSPACE,
        name: ERouterName.WORKSPACE,
        component: () => import('/@/pages/page-web/projects/workspace.vue'), // 工作中心
        redirect: '/' + ERouterName.TSA,
        children: [
          // {
          //   path: '/' + ERouterName.TSA,
          //   name: ERouterName.TSA,
          //   component: () => import('/@/pages/page-web/projects/tsa.vue') // 工作空间————主页
          // },
          // {
          //   path: '/' + ERouterName.LAYER,
          //   name: ERouterName.LAYER,
          //   component: () => import('/@/pages/page-web/projects/layer.vue') // 工作空间————地图
          // },

          // {
          //   path: '/' + ERouterName.WAYLINE,
          //   name: ERouterName.WAYLINE,
          //   component: () => import('/@/pages/page-web/projects/wayline.vue') // 工作空间————航线
          // },
          {
            path: '/wayline-edit/:id',
            name: 'WaylineEdit',
            component: () => import('/@/pages/page-web/projects/wayline_edit.vue')
          },
          {
            path: '/wayline-edit-planar/:id',
            name: 'WaylineEditPlanar',
            component: () => import('/@/pages/page-web/projects/wayline_edit_planar.vue')
          },
          {
            path: '/wayline-edit-strip/:id',
            name: 'WaylineEditStrip',
            component: () => import('/@/pages/page-web/projects/wayline_edit_strip.vue')
          },
          {
            path: '/' + ERouterName.TASK,
            name: ERouterName.TASK,
            component: () => import('/@/pages/page-web/projects/task.vue'), // 工作空间————任务计划
            children: [
              {
                path: ERouterName.CREATE_PLAN,
                name: ERouterName.CREATE_PLAN,
                component: CreatePlan,
                children: [
                  {
                    path: ERouterName.SELECT_PLAN,
                    name: ERouterName.SELECT_PLAN,
                    components: {
                      WaylinePanel,
                      DockPanel
                    }
                  }
                ]
              }

            ]
          },
          // {
          //   path: '/' + ERouterName.FLIGHT_AREA,
          //   name: ERouterName.FLIGHT_AREA,
          //   component: () => import('/@/pages/page-web/projects/flight/flight-area.vue') // 工作空间————飞行区域
          // },
        ]
      },

      // {
      //   path: '/' + ERouterName.MEDIA,
      //   name: ERouterName.MEDIA,
      //   component: () => import('/@/components/MediaPanel.vue') // 工作空间————媒体
      // },

      // {
      //   path: '/' + ERouterName.MEMBERS,
      //   name: ERouterName.MEMBERS,
      //   component: () => import('/@/pages/page-web/projects/members.vue') // 员工管理
      // },
      // {
      //   path: '/' + ERouterName.DEVICES,
      //   name: ERouterName.DEVICES,
      //   component: () => import('/@/pages/page-web/projects/devices.vue') // 设备管理
      // },
      // {
      //   path: '/' + ERouterName.FIRMWARES,
      //   name: ERouterName.FIRMWARES,
      //   component: () => import('/@/pages/page-web/projects/Firmwares.vue') // 固件管理
      // },
      // {
      //   path: '/' + ERouterName.MENU,
      //   name: ERouterName.MENU,
      //   component: () => import('/@/pages/page-web/projects/menu.vue') // 菜单管理
      // },
      {
        path: '/' + ERouterName.DICT,
        name: ERouterName.DICT,
        component: () => import('/@/pages/page-web/projects/manage/dict.vue') // 字典管理
      },
      // {
      //   path: '/' + ERouterName.MENU,
      //   name: ERouterName.MENU,
      //   component: () => import('/@/pages/page-web/projects/menu.vue') // 菜单管理
      // },
      {
        path: '/' + ERouterName.ROLE,
        name: ERouterName.ROLE,
        component: () => import('/@/pages/page-web/projects/manage/role.vue') // 角色管理
      },
      // {
      //   path: '/' + ERouterName.INST_LOG,
      //   name: ERouterName.INST_LOG,
      //   component: () => import('/@/pages/page-web/projects/manage/inst-log.vue') // 指令日志
      // },
      // {
      //   path: '/' + ERouterName.USER,
      //   name: ERouterName.USER,
      //   component: () => import('/@/pages/page-web/projects/user.vue') // 个人中心
      // },
      // {
      //   path: '/' + ERouterName.ORG,
      //   name: ERouterName.ORG,
      //   component: () => import('/@/pages/page-web/projects/manage/org.vue') // 组织列表
      // },
      // {
      //   path: '/' + ERouterName.ALG,
      //   name: ERouterName.ALG,
      //   component: () => import('/@/pages/page-web/projects/alarm/alarm-algorithm.vue') // 算法库
      // },
      {
        path: '/' + ERouterName.ALARM_DISPOSITION,
        name: ERouterName.ALARM_DISPOSITION,
        component: () => import('/@/pages/page-web/projects/alarm/alarm-disposition.vue') // 告警配置
      },
      // {
      //   path: '/' + ERouterName.ALARM,
      //   name: ERouterName.ALARM,
      //   component: () => import('/@/pages/page-web/projects/alarm/alarm.vue') // 告警库
      // },
      // {
      //   path: '/' + ERouterName.FLIGHT_PLAN,
      //   name: ERouterName.FLIGHT_PLAN,
      //   component: () => import('/@/pages/page-web/projects/flightPlan/index.vue'), // 飞行计划
      // },
      // {
      //   path: '/' + ERouterName.REPORT,
      //   name: ERouterName.REPORT,
      //   component: () => import('/@/pages/page-web/projects/report.vue'), // 报告
      // },
      // {
      //   path: '/' + ERouterName.INDIVIDUAL_TASK,
      //   name: ERouterName.INDIVIDUAL_TASK,
      //   component: () => import('/@/pages/page-web/projects/individual-task.vue') // 单兵任务
      // },
      {
        path: '/' + ERouterName.TEST,
        name: ERouterName.TEST,
        component: () => import('/@/components/test.vue')
      },
      {
        path: '/' + ERouterName.FLIGHT_REPORT,
        name: ERouterName.FLIGHT_REPORT,
        component: () => import('/@/pages/page-web/projects/flight/flight-notification-approval.vue'), // 飞行报备
      },
      // {
      //   path: '/' + ERouterName.FLIGHT_TRAJECTORY,
      //   name: ERouterName.FLIGHT_TRAJECTORY,
      //   component: () => import('/@/pages/page-web/projects/flight/flight-trajectory.vue') // 飞行轨迹
      // },
      // {
      //   path: '/' + ERouterName.LIVESTREAM,
      //   name: ERouterName.LIVESTREAM,
      //   component: () => import('/@/pages/page-web/projects/livestream.vue'), // 工作空间————视频墙
      //   children: [
      //     {
      //       path: ERouterName.LIVING,
      //       name: ERouterName.LIVING,
      //       components: {
      //         LiveAgora,
      //         LiveOthers
      //       }
      //     }
      //   ]
      // },
      {
        path: '/task/:id',
        name: 'TaskDetail',
        component: () => import('/@/pages/page-web/projects/task-detail.vue')
      },
      {
        path: '/drone-controller/:sn',
        name: 'droneController', // 必须与跳转时使用的name一致
        component: () => import('/@/pages/page-web/projects/drone_controller.vue'),
      },
      {
        path: '/fly-controller/:sn',
        name: 'flyController', // 必须与跳转时使用的name一致
        component: () => import('/@/pages/page-web/projects/fly_controller.vue')
      },
      // {
      //   path: '/' + ERouterName.DATA_UI,
      //   name: ERouterName.DATA_UI, // 必须与跳转时使用的name一致
      //   component: () => import('/@/pages/page-web/data/index.vue')
      // },
      {
        path: '/digital-twin',
        name: 'DigitalTwin',
        component: () => import('/@/pages/page-web/digital-twin.vue')
      }
    ]
  },
]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})
// 路由前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title as string
  }
  next()
})

if (!ELocalStorageKey.Token) {
  router.push('/')
}

export default router
